// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"180": "18c6a98e6991c2d2","419": "d360b9e4d817ca5f","673": "9fc7a8de2f68d760",}[chunkId] + ".css"
}